import { render, staticRenderFns } from "./FileContainer.vue?vue&type=template&id=4ff5fcde&scoped=true"
import script from "./FileContainer.vue?vue&type=script&lang=js"
export * from "./FileContainer.vue?vue&type=script&lang=js"
import style0 from "./FileContainer.vue?vue&type=style&index=0&id=4ff5fcde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff5fcde",
  null
  
)

export default component.exports